export const stringIsValidId = (str: string) => /^-?\d+$/.test(str);

export const castIriToId = (iri: string) => {
    const stringId = iri.split('/').pop();
    if (stringId && stringIsValidId(stringId)) {
        return Number(stringId);
    }
    throw new Error('String is not an iri-reference');
};
